import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
})

let token = ''
let type = ''
let sid = ''
let arr = ['student', 'teacher', 'school']

instance.interceptors.request.use(
  function (config) {
    if (location.href.indexOf('school') != -1) {
      type = 3
      sid = localStorage.getItem('school')
        ? JSON.parse(localStorage.getItem('school')).sid
        : ''
    }
    if (location.href.indexOf('teacher') != -1) {
      type = 2
      sid = localStorage.getItem('class')
        ? JSON.parse(localStorage.getItem('class')).sys_class_id
        : ''
    }
    if (location.href.indexOf('student') != -1) {
      type = 1
      sid = localStorage.getItem('student')
        ? JSON.parse(localStorage.getItem('student')).sid
        : ''
    }
    if (type && localStorage.getItem(`${arr[type - 1]}_token`)) {
      token = localStorage.getItem(`${arr[type - 1]}_token`)
    }

    if (token) {
      config.headers.token = token
      config.headers.numbers = sid
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  function (response) {
    return response.data
  },
  function (error) {
    if (error.response) {
      if (error.response.status == 401) {
        localStorage.removeItem(`${arr[type - 1]}_token`)
        window.location.href = '/#/login'
      }
    }
    return Promise.reject(error)
  }
)

export default instance
